import { useQuery } from 'react-query';

import { QueryFunction, useRequest } from '@frontend/api';

import type { SearchData } from '../common';
import { getUseSearchOrdersQueryKey, UseSearchOrdersQueryKey } from './keys';
import type { UseSearchOrdersParams } from './types';

export const useSearchOrders: QueryFunction<
  SearchData,
  [body: UseSearchOrdersParams],
  UseSearchOrdersQueryKey
> = (body, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useQuery({
    ...queryOptions,
    queryKey: getUseSearchOrdersQueryKey(body),
    queryFn: ({ signal }) =>
      request('/search/orders', {
        init: {
          signal,
          method: 'POST',
          body: {
            ...body,
          },
        },
      }),
  });
};
